import Support from '@/views/support'
import SearchDocument from '@/views/support/document/search'
import LocationDocument from '@/views/support/document/location'
import MapMatchDocument from '@/views/support/document/mapmatch'
import PathPlanDocument from '@/views/support/document/routing'
import RegionQueryDocument from '@/views/support/document/division'
import GeoCodingDocument from '@/views/support/document/geo'
import StatusCode from '@/views/support/document/StatusCode'
import UpdateLog from '@/views/support/document/UpdateLog'

export default {
  path: '/support',
  component: Support,
  meta: {
    title: '开发支持'
  },
  children: [{
    path: '/support/search',
    name: 'SearchDocument',
    component: SearchDocument
  },
  {
    path: '/support/geo',
    name: 'GeoCodingDocument',
    component: GeoCodingDocument
  },
  {
    path: '/support/regeo',
    name: 'LocationDocument',
    component: LocationDocument
  },
  {
    path: '/support/mapmatch',
    name: 'MapMatchDocument',
    component: MapMatchDocument
  },
  {
    path: '/support/division',
    name: 'RegionQueryDocument',
    component: RegionQueryDocument
  },
  {
    path: '/support/routing',
    name: 'PathPlanDocument',
    component: PathPlanDocument
  },
  {
    path: '/support/status',
    name: 'StatusCode',
    component: StatusCode
  },
  {
    path: '/support/updatelog',
    name: 'UpdateLog',
    component: UpdateLog
  }
  ]
}
